module.exports = __webpack_public_path__ + "static/img/one.06f68cf.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/appleImg/one.png
// module id = ozAc
// module chunks = 1